const en = {
  "YES": "Yes",
  "NO": "No",
  "ID": "Id",
  "ARE_YOU_SURE": "Are you sure?",
  "SUBMIT": "Submit",
  "NO_DATA": "no data",
}
export default en;